import OrdersService from './ordersService';
import TixLogger from './tixEventLogger';
import TixService from './tixService';
import WapiService, {
    initService,
    injectStore,
    getCarrierInfo,
    getInterlinkC2CData,
    getInterlinkHomepageData,
    getSplitTestConfiguration,
    getSupportedCurrencies,
} from './wapiService';

export {
    OrdersService,
    TixLogger,
    TixService,
    WapiService,
    getCarrierInfo,
    getInterlinkC2CData,
    getInterlinkHomepageData,
    getSplitTestConfiguration,
    getSupportedCurrencies,
    initService,
    injectStore,
};

export default WapiService;
